<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9.77284 11.8586C9.69473 11.9367 9.69473 12.0634 9.77284 12.1415L16.0657 18.4344C16.3781 18.7468 16.3781 19.2533 16.0657 19.5657C15.7533 19.8782 15.2468 19.8782 14.9344 19.5657L8.64147 13.2728C7.93852 12.5699 7.93852 11.4302 8.64147 10.7273L14.9344 4.43436C15.2468 4.12194 15.7533 4.12194 16.0657 4.43436C16.3781 4.74678 16.3781 5.25332 16.0657 5.56573L9.77284 11.8586Z"
			:fill="props.iconColor"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
